import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15.834"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M14.167 0H.833A.833.833 0 0 0 0 .833v2.159a1.68 1.68 0 0 0 .486 1.173L5 8.678V15a.834.834 0 0 0 1.206.746l3.333-1.667a.83.83 0 0 0 .461-.746V8.678l4.514-4.514A1.67 1.67 0 0 0 15 2.992V.833A.833.833 0 0 0 14.167 0M8.578 7.744a.83.83 0 0 0-.244.589v4.485l-1.667.833V8.333a.83.83 0 0 0-.244-.589L1.667 2.992V1.667h11.667v1.319L8.576 7.744Z" }, null, -1)
  ])))
}
export default { render: render }